/*eslint no-unused-vars: ["error", { "args": "none" }]*/

import {
  AUTH_LOGIN,
  LOGIN_SUCCESS,
  FETCH_AUTH_USER,
  SET_AUTH_USER,
  LOGOUT,
  AUTH_RESET_PASSWORD,
  VERIFY_RESET_TOKEN,
  RESET_PASSWORD
} from "../types";
import { api } from "../../utils";

export default {
  getters: {},
  state: {
    isLoggedIn: !!localStorage.getItem("user"),
    user: null,
  },
  mutations: {
    [LOGIN_SUCCESS]: (state, payload) => {
      state.isLoggedIn = true;
      state.user = payload.user;
    },
    [SET_AUTH_USER]: (state, payload) => {
      state.user = payload.user;
    },
    [LOGOUT]: (state, payload) => {
      state.isLoggedIn = false;
      state.user = null;
      localStorage.removeItem("user");
    },
  },
  actions: {
    [AUTH_LOGIN]: ({ dispatch, commit }, authPayload) => {
      return api("/auth/login", "POST", authPayload, false).then(data => {
        const { token, user } = data;
        localStorage.setItem(
          "user",
          JSON.stringify({
            id: user.id,
            token,
          })
        );
        commit({
          type: LOGIN_SUCCESS,
          user
        });
      });
    },
    [FETCH_AUTH_USER]: ({ dispatch, commit }) => {
      return api("/auth/current", "POST", {}).then(res => {
        let user = res.data;
        commit({
          type: SET_AUTH_USER,
          user,
        });
      });
    },
    [VERIFY_RESET_TOKEN]: ({ dispatch, commit }, payload) => {
      return api("/auth/verify-reset", "POST", payload.data).then(res => {
        return res;
      });
    },
    [RESET_PASSWORD]: ({ dispatch, commit }, payload) => {
      return api("/auth/forgot-password", "POST", payload.data).then(res => {
        return res;
      });
    },
    [AUTH_RESET_PASSWORD]: ({ dispatch, commit }, payload) => {
      return api("/auth/reset-password", "POST", payload, false).then(data => {
        const { token, user } = data;
        localStorage.setItem(
          "user",
          JSON.stringify({
            id: user.id,
            token,
          })
        );
        commit({
          type: LOGIN_SUCCESS,
          user
        });
      });
    },
  }
}